<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white p-5 rounded-2xl"
    >
      <!-- <h3 class="text-lg font-semibold text-textblues mb-2">Bulk Upload Form</h3> -->

      <form @submit.prevent="handleSubmitcsv" class="space-y-3" ref="clearRef">
        <div class="flex flex-col gap-3 w-full">
          <div class="flex justify-between">
            <label for="attachments" class="text-left flex items-center"
              >Bulk Upload *
              <div class="relative group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div
                  class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                >
                  Only CSV files in the sample format are allowed.
                </div>
              </div>
            </label>
            <div class="w-[20%] flex justify-center items-center">
              <a
                href="https://alliance-lms-dev.s3.ap-south-1.amazonaws.com/media/uploaded_videos/bulk_upload1_zqVTf6K.csv"
                download
                class="w-full flex gap-1 items-center justify-center tooltip"
              >
                <img
                  src="@/assets/newd/download.png"
                  alt="download file"
                  class="w-4 h-4 object-contain"
                />
                <span class="tooltiptext text-xs w-full"> Sample File</span>
              </a>
            </div>
          </div>
          <input
            id="source"
            type="file"
            class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
            accept=".csv,text/csv"
            @change="inputchange"
          />
        </div>

        <div class="flex justify-end">
          <!-- <button
            type="submit"
            class="bg-blues text-white px-4 py-2 text-xs font-bold rounded-lg hover:bg-hover"
          >
            Submit
          </button> -->
          <div class="flex items-center gap-3">
            <button
              type="submit"
              :disabled="disable_submit == true"
              :class="
                this.disable_submit == true
                  ? 'bg-gray-200 text-black cursor-not-allowed'
                  : 'bg-blues hover:bg-hover cursor-pointer text-white'
              "
              class="rounded-lg text-sm px-6 py-2"
            >
              Submit
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="flex items-center justify-between mt-6 mb-4">
      <div class="flex items-center gap-2">
        <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
        <span v-if="totalcount" class="mb-3"> ({{ totalcount || 0 }}) </span>
      </div>
      <div class="relative w-full md:max-w-80">
        <div
          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <input
          type="text"
          v-model="searching"
          @input="getsubmit(1)"
          placeholder="Search..."
          class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
        />
        <button
          v-if="searching"
          @click="clearSearch"
          class="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 hover:text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
    <div v-if="submittedData.length > 0">
      <div
        class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
      >
        <table class="min-w-full text-sm">
          <thead class="bg-gray-100 whitespace-nowrap">
            <tr>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
              >
                S.NO
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
              >
                First Name
              </th>
              <th
                class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
              >
                Last Name
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
              >
                Mobile No
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
              >
                Email
              </th>

              <th
                class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
              >
                Role
              </th>
              <th class="py-3 px-4 border-b font-semibold text-textblues text-left">
                Created Date
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-100 bg-white">
            <tr
              v-for="(item, index) in submittedData"
              :key="index"
              class="hover:bg-gray-50 transition whitespace-nowrap"
            >
              <td class="py-2 px-4 border-r text-gray-700">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </td>

              <td
                class="py-2 px-4 border-r text-xs text-gray-500 font-medium uppercase"
              >
                {{ item.first_name || "NA" }}
              </td>
              <td class="py-2 px-4 border-r text-xs text-gray-500 font-medium">
                {{ item.last_name || "NA" }}
              </td>

              <td class="py-2 px-4 border-r text-xs text-gray-500 font-medium">
                {{ item.phone_number || "NA" }}
              </td>

              <td class="py-2 px-4 border-r text-xs text-gray-500 font-medium">
                {{ item.email || "NA" }}
              </td>

              <td class="py-2 px-4 text-xs border-r text-gray-500 font-medium">
                {{ item.role || "NA" }}
              </td>
              <td class="py-3 px-4 text-left text-xs text-gray-500 font-medium">
                {{ item.created_at ? formatDate(item.created_at) : "NA" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="pb-5 flex items-center justify-center">
          <Pagination :totalPages="totalPages" @page-changed="getsubmit" />
        </div> -->
      <div
        class="flex flex-col sm:flex-row justify-center gap-3 pb-[20px] relative"
      >
        <!-- PAGE SIZE -->
        <div
          class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
        >
          <span class="flex md:hidden">Rows per page:</span>
          <select
            v-model="pageSize"
            @change="onPageSizeChange"
            class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>

        <!-- PAGINATION -->
        <div v-if="totalPages > 1" class="flex justify-center">
          <Pagination
            :totalPages="totalPages"
            ref="paginationRef"
            @page-changed="getsubmit"
          />
        </div>
      </div>
    </div>

    <div v-else class="text-center text-gray-500 py-6">No Data Found</div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import phoneLength from "@/mixins/phoneLength";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      firstName: "",
      searching: "",
      lastName: "",
      email: "",
      countryCode: "+91",
      phone_max_length: "",
      mobile: "",
      passwordOption: "custom",
      password: "",
      role: "",
      max_length: 10,
      rols: [],
      submittedData: [],
      messages: {
        text: "",
        type: "null",
      },
      totalPages: 1,
      currentPage: 1,
      pageSize: 10,
      totalcount: "",
      disable_submit: false,
    };
  },

  components: {
    FlashMessage,
    Pagination,
  },

  mixins: [countryCodeMixins, phoneLength],
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.password = this.generatePassword();
      } else {
        this.password = "";
      }
    },
  },
  computed: mapGetters(["userInfo"]),
  async created() {
    this.getrole();
    this.getsubmit(1);
  },
  mounted() {},
  methods: {
    clearSearch() {
      this.searching = "";
      this.getsubmit(1);
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getsubmit(1);
    },
    inputchange(event) {
      const file = event.target.files[0];

      if (!file) return;

      const fileName = file.name.toLowerCase();

      if (!fileName.endsWith(".csv")) {
        alert("Please upload a valid CSV file.");

        event.target.value = "";

        return;
      }

      console.log(file);
      this.selectedFile = file;
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    handleSubmitcsv(el) {
      this.disable_submit = true;
      let formData = new FormData();
      // formData.append("title", el.target.elements.file_title.value);
      // formData.append("description", el.target.elements.file_description.value);
      formData.append("file", el.target.elements.source.files[0]);
      // https://al-lms-api.galecta.com/media/bulk_upload.csv
      axios
        .post(
          `${process.env.VUE_APP_API}/enrollement-bulk-csv-upload/new/?Key=${this.userInfo.token_key}`,
          formData,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.getsubmit(1);
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.disable_submit = false;

            this.$refs.clearRef.reset();

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          } else {
            this.messages = {
              text: response.data.error || response.data.message,
              type: "error",
            };
            this.disable_submit = false;
            this.$refs.clearRef.reset();
            console.log("Response:", response.data);

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .catch((error) => {
          console.log("API Error:", error.response);
          this.messages = {
            text:
              error.response?.data?.error ||
              error.response?.data?.message ||
              error.message ||
              "CSV upload failed.",
            type: "error",
          };
          this.disable_submit = false;
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 2000);
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    getrole() {
      axios
        .get(
          `${process.env.VUE_APP_API}/permission-list/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.rols = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getsubmit(number) {
      this.currentPage = number;
      axios
        .get(
          `${process.env.VUE_APP_API}/staff-enrollment-list/?Key=${this.userInfo.token_key}&page=${number}&page_size=${this.pageSize}&search=${this.searching}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
            this.totalcount = response.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* tool tip  */
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 40%;
  /* background-color: #17469E; */
  /* color: #fff; */
  color: #17469e;
  text-align: center;
  border: 1px solid #17469e;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  bottom: -8px;
  left: 20px;
  z-index: 1;
}
.wrapper-class {
  max-width: 200px;
  word-wrap: break-word;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
